import { Card } from '@heroui/react'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Database, MapPin, Store } from 'lucide-react'
import { authApiClient } from '~/lib/api-client'

export const Route = createFileRoute('/admin/')({
  component: AdminDashboard,
})

function AdminDashboard() {
  const { data: stats } = useSuspenseQuery({
    queryKey: ['admin', 'stats'],
    queryFn: async () => {
      const res = await authApiClient.admin.stats.$get({
        header: { Authorization: '' },
      })
      if (!res.ok) {
        throw new Error(`Failed to fetch admin stats: ${res.status} ${res.statusText}`)
      }
      return await res.json()
    },
  })

  const metrics = [
    { label: '店铺总数', value: stats.shopCount.toLocaleString(), icon: Store, iconColor: 'text-blue-500' },
    { label: '分类总数', value: stats.categoryCount.toLocaleString(), icon: Database, iconColor: 'text-purple-500' },
    { label: '区域总数', value: stats.regionCount.toLocaleString(), icon: MapPin, iconColor: 'text-emerald-500' },
  ]

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">控制台概览</h1>
        <p className="text-muted text-lg mt-1">TabeTabi 管理后台 — 系统实时数据概览。</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {metrics.map((stat) => (
          <Card key={stat.label} className="p-6" variant="secondary">
            <div className="flex items-center gap-3 mb-3">
              <stat.icon className={`size-5 ${stat.iconColor}`} />
              <p className="text-sm font-medium text-muted">{stat.label}</p>
            </div>
            <h2 className="text-3xl font-bold">{stat.value}</h2>
          </Card>
        ))}
      </div>
    </div>
  )
}
